import React from "react";
import sort from "icons/sorting-purple.svg";
import Dropdown, {
  dropdownTypes,
} from "@visiblethread/react-components/dist/components/Dropdown";
import ButtonsDropdownOption from "@visiblethread/react-components/dist/components/Dropdown/ButtonsDropdownOption";
import { buttonVariants } from "@visiblethread/react-components/dist/components/Button";
import { useDispatch } from "react-redux";
import { filterUsers } from "slices/systemAdmin/systemAdminSlice";
import {
  FILTER_ALL,
  FILTER_LICENSED,
  FILTER_MEMBERS,
  FILTER_NON_MEMBERS,
  FILTER_SYSTEM_ADMINS,
} from "constants/systemAdmin";

const UsersFilter = () => {
  const dispatch = useDispatch();

  const dropdownButton = () => (
    <span title="Filter Users">
      Filter Users <img src={sort} alt="sort" />
    </span>
  );

  const dropdownOptions = () => {
    const options = [];

    options.push(
      <ButtonsDropdownOption
        content={<span>All</span>}
        onClick={() => {
          dispatch(filterUsers(FILTER_ALL));
        }}
      />
    );

    options.push(
      <ButtonsDropdownOption
        content={<span>Licensed Users</span>}
        onClick={() => {
          dispatch(filterUsers(FILTER_LICENSED));
        }}
      />
    );

    options.push(
      <ButtonsDropdownOption
        content={<span>Members Only</span>}
        onClick={() => {
          dispatch(filterUsers(FILTER_MEMBERS));
        }}
      />
    );

    options.push(
      <ButtonsDropdownOption
        content={<span>Non-Members</span>}
        onClick={() => {
          dispatch(filterUsers(FILTER_NON_MEMBERS));
        }}
      />
    );

    options.push(
      <ButtonsDropdownOption
        content={<span>System Admins</span>}
        onClick={() => {
          dispatch(filterUsers(FILTER_SYSTEM_ADMINS));
        }}
      />
    );

    return options;
  };

  return (
    <div className="users__filter" data-testid="users-filter">
      <Dropdown
        type={dropdownTypes.buttons}
        propsObject={{
          button: dropdownButton(),
          options: dropdownOptions(),
          hideArrowIcon: true,
          buttonVariant: buttonVariants.secondary,
        }}
      />
    </div>
  );
};

export default UsersFilter;
